import React from "react";

import HomeComponent from "../../components/Home/Home";
import StudentProfileSelectionModal from "../../components/StudentDetails/StudentProfileSelectionModal";
import ErrorSnackbar from "../../widgets/Snackbar/ErrorSnackbar";
import { useStudentSearch } from "./hooks/useStudentSearch";

const Home = () => {
  const {
    formik,
    selectedBranch,
    setSelectedBranch,
    errorSnackbar,
    closeErrorSnackbar,
    profilesModal,
    closeProfilesModal,
    fetchSchoolBranches,
    handleProfileSelect,
  } = useStudentSearch();

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    touched,
    handleBlur,
    isSubmitting,
    setFieldValue,
    setValues,
  } = formik;

  return (
    <>
      <HomeComponent
        values={values}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        touched={touched}
        handleBlur={handleBlur}
        isSubmitting={isSubmitting}
        setFieldValue={setFieldValue}
        setValues={setValues}
        selectedBranch={selectedBranch}
        setSelectedBranch={setSelectedBranch}
        fetchSchoolBranches={fetchSchoolBranches}
      />

      <StudentProfileSelectionModal
        open={profilesModal.open}
        onClose={closeProfilesModal}
        profiles={profilesModal.profiles}
        onSelectProfile={(row) =>
          handleProfileSelect(row, profilesModal.searchValues)
        }
      />

      <ErrorSnackbar
        open={errorSnackbar.open}
        message={errorSnackbar.message}
        onClose={closeErrorSnackbar}
      />
    </>
  );
};

export default Home;
